/**
 * Días hábiles por mes de la columna Cobertura en Salud de inventario: 30 × 5 / 7.
 * Misma constante que `apply_adjusted_monthly_avg_sales_to_rows` en policy_scope.
 */
export const INVENTORY_HEALTH_WORKING_DAYS_PER_MONTH = (30 * 5) / 7;

/**
 * Días de cobertura = numerador × (30 × 5 / 7) / ventas mensuales históricas.
 * Misma fórmula que la columna Cobertura de Salud de inventario.
 * Sin ventas históricas (> 0) no hay ritmo: null.
 * Stock negativo cuenta como 0 (la celda de Salud muestra 0).
 * El entero es el redondeo de la celda de Salud (2 decimales y luego al entero).
 */
export function coverageDaysFromHistoricalSales(
  numerator: number,
  monthlyAvgSales: number | null | undefined,
): number | null {
  const monthly = Number(monthlyAvgSales);
  if (!Number.isFinite(monthly) || monthly <= 0) return null;
  const rawUnits = Number(numerator);
  if (!Number.isFinite(rawUnits)) return null;
  const units = Math.max(0, rawUnits);
  const exact = (units * INVENTORY_HEALTH_WORKING_DAYS_PER_MONTH) / monthly;
  const roundedToHealth = Math.round(exact * 100) / 100;
  return Math.round(roundedToHealth);
}

export function formatCoverageQty(value: number): string {
  if (!Number.isFinite(value)) return '0';
  const rounded = Math.round(value * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
}
